import { apiRequest } from '../client';
import { tryGetApiToken } from '../authToken';

async function withClientToken(path, options = {}) {
  const token = await tryGetApiToken();
  return apiRequest(path, { ...options, token });
}

export async function getStorefrontCompanyById(companyId) {
  const result = await apiRequest(`/api/public/companies/${encodeURIComponent(companyId)}`);
  return result.company || null;
}

export async function getStorefrontCompanyByIdOrNull(companyId) {
  try {
    return await getStorefrontCompanyById(companyId);
  } catch (error) {
    if (error?.status === 404) return null;
    throw error;
  }
}

export async function listMyStorefrontAppointments({ companyId, archived } = {}) {
  const params = new URLSearchParams();
  if (archived != null) params.set('archived', String(archived));
  const query = params.toString();
  const result = await withClientToken(
    `/api/public/companies/${encodeURIComponent(companyId)}/my-appointments${query ? `?${query}` : ''}`
  );
  return result.appointments || [];
}

export async function getAppointmentConfirmationStatus(token) {
  const result = await apiRequest(`/api/public/appointments/confirm/${encodeURIComponent(token)}`);
  return result;
}

export async function confirmAppointmentByToken(token) {
  return apiRequest(`/api/public/appointments/confirm/${encodeURIComponent(token)}`, {
    method: 'POST',
    body: {},
  });
}

export async function getAppointmentCheckInStatus(token) {
  return apiRequest(`/api/public/appointments/check-in/${encodeURIComponent(token)}`);
}

export async function checkInAppointmentByToken(token) {
  return apiRequest(`/api/public/appointments/check-in/${encodeURIComponent(token)}`, {
    method: 'POST',
    body: {},
  });
}

export async function cancelStorefrontAppointment({ companyId, appointmentId, cancelReason }) {
  return withClientToken(
    `/api/public/companies/${encodeURIComponent(companyId)}/appointments/${encodeURIComponent(appointmentId)}/cancel`,
    {
      method: 'POST',
      body: { cancelReason },
    }
  );
}

export async function confirmStorefrontAppointment({ companyId, appointmentId }) {
  return withClientToken(
    `/api/public/companies/${encodeURIComponent(companyId)}/appointments/${encodeURIComponent(appointmentId)}/confirm`,
    {
      method: 'POST',
      body: {},
    }
  );
}

export async function checkInStorefrontAppointment({ companyId, appointmentId }) {
  return withClientToken(
    `/api/public/companies/${encodeURIComponent(companyId)}/appointments/${encodeURIComponent(appointmentId)}/check-in`,
    {
      method: 'POST',
      body: {},
    }
  );
}

export async function submitStorefrontAppointmentRating({
  companyId,
  appointmentId,
  rating,
  comment,
  employeeId,
  appointmentDate,
  clientName,
  serviceName,
  employeeName,
}) {
  return withClientToken(
    `/api/public/companies/${encodeURIComponent(companyId)}/appointments/${encodeURIComponent(appointmentId)}/rating`,
    {
      method: 'POST',
      body: {
        rating,
        comment,
        employeeId,
        appointmentDate,
        clientName,
        serviceName,
        employeeName,
      },
    }
  );
}

export async function rescheduleStorefrontAppointment({ companyId, appointmentId, dateTime, endTime }) {
  return withClientToken(
    `/api/public/companies/${encodeURIComponent(companyId)}/appointments/${encodeURIComponent(appointmentId)}/reschedule`,
    {
      method: 'POST',
      body: {
        dateTime: dateTime instanceof Date ? dateTime.toISOString() : dateTime,
        endTime: endTime instanceof Date ? endTime.toISOString() : endTime,
      },
    }
  );
}
